.tasksTable :global(.ant-table-tbody > tr > td) {
  vertical-align: middle;
}

.linkedTaskRow > :global(.ant-table-cell) {
  background: var(--ant-color-primary-bg);
}
